// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"83a3f44d","453":"082c6399"}[chunkId] + ".chunk.js";
};